/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.searchModule')

/**
 * BulbSearchService encapsulates the search and suggest server requests.
 */
  .service('BulbSearchService', ['Restangular', 'RecordEventService', BulbSearchService]);

function BulbSearchService(Restangular, RecordEventService) {
  this.searchResource = Restangular.all('search');

  /**
   * Return search results from the server.
   * @param query The search query.
   * @param userUnitId The portfolio owner unit id, if searching a single portfolio.
   * @param scope The requested search scope.
   * @param from The index into the search results of the first result to return.
   * @param size The number of search results to return.
   * @returns A promise resolving to a search results rest reply.
   */
  this.search = function search(query, userUnitId, scope, from, size) {
    RecordEventService.recordEvent('search_submitted', 'search', 'user_performed_search');
    return this.searchResource.customGET('', {
      query,
      userUnitId,
      scope,
      from,
      size,
    });
  };

  /**
   * Return a list of suggestions for the user's typed-so-far search query prefix.
   * @param prefix The user's typed-so-far query.
   * @returns A promise resolving to an array of zero or more suggestions beginning with the user's prefix.
   */
  this.suggest = function suggest(prefix) {
    return this.searchResource.customGETLIST('suggest', {
      prefix,
      filter: null,
      sort: null,
    });
  };
}
